import Chapter from "@/components/Chapter";
import Reveal from "@/components/Reveal";
import { MARKETS } from "@/data/content";
import { Ship, Plane, FileCheck } from "lucide-react";

const Markets = () => (
  <section id="markets" data-testid="markets-served-section" className="grain-overlay relative bg-navy py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Chapter
        dark
        index="07"
        eyebrow="Markets Served"
        title="Trusted across 18+ countries."
        description="Fashion houses, home décor brands and fabric converters rely on Bhagalpur weaving — coordinated end-to-end from our Kolkata export office."
      />

      <div className="mt-14 grid gap-12 lg:grid-cols-[1.5fr_1fr]">
        <div className="divide-y divide-white/10 border-y border-white/10">
          {MARKETS.map((m, i) => (
            <Reveal key={m.region} delay={i * 0.05}>
              <div
                data-testid={`market-${m.region.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group flex flex-col gap-1 py-6 sm:flex-row sm:items-baseline sm:justify-between"
              >
                <span className="font-serif text-2xl font-medium text-white transition-colors duration-300 group-hover:text-gold">
                  {m.region}
                </span>
                <span className="text-sm text-slate-400">{m.detail}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="border border-gold/30 bg-white/[0.04] p-8 backdrop-blur-sm">
            <h3 className="font-serif text-xl font-medium text-white">Logistics, handled</h3>
            <ul className="mt-6 space-y-5 text-sm leading-relaxed text-slate-300">
              <li className="flex gap-4">
                <Ship size={18} className="mt-0.5 shrink-0 text-gold" />
                <span>FOB sea freight via Kolkata / Haldia port with full export documentation.</span>
              </li>
              <li className="flex gap-4">
                <Plane size={18} className="mt-0.5 shrink-0 text-gold" />
                <span data-testid="markets-air-courier-detail">
                  Samples and urgent lots dispatched by air through FedEx and DHL from Kolkata (CCU) within days of approval.
                </span>
              </li>
              <li className="flex gap-4">
                <FileCheck size={18} className="mt-0.5 shrink-0 text-gold" />
                <span>Customs paperwork, certificates of origin and inspection reports managed by our Kolkata office.</span>
              </li>
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Markets;
